import { Quote } from "lucide-react";
import { MAGGIE_STORY } from "@/data/slate";

const MAGGIE_PORTRAIT_URL = "/images/maggie-portrait-optimized.webp";

const CaseStudy = () => (
    <section
        id="case-study"
        data-testid="case-study-section"
        className="border-b border-border bg-card"
    >
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
            <div className="grid gap-16 md:grid-cols-12">
                <div className="md:col-span-5">
                    <div className="relative">
                        <div className="absolute -inset-3 border border-border" aria-hidden />
                        <img
                            data-testid="maggie-portrait"
                            src={MAGGIE_PORTRAIT_URL}
                            alt={`Portrait of ${MAGGIE_STORY.name}`}
                            className="relative h-[480px] w-full object-cover object-top"
                        />
                    </div>
                    <p className="mt-6 font-serif text-xl text-foreground">
                        {MAGGIE_STORY.name}
                    </p>
                    <p className="text-sm uppercase tracking-[0.25em] text-muted-foreground">
                        {MAGGIE_STORY.title}
                    </p>
                </div>

                <div className="md:col-span-7">
                    <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                        Maggie&apos;s story
                    </p>
                    <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl">
                        Twenty-five years of expertise.
                        <br />
                        <span className="italic">Sixty days </span>
                        to find the right next chapter.
                    </h2>

                    <div className="mt-10 flex items-start gap-4">
                        <Quote size={28} strokeWidth={1} className="shrink-0 text-foreground" />
                        <blockquote className="font-serif text-2xl italic leading-snug text-foreground md:text-3xl">
                            {MAGGIE_STORY.quote}
                        </blockquote>
                    </div>

                    <div className="mt-12 grid grid-cols-3 gap-px border border-border bg-border">
                        {MAGGIE_STORY.metrics.map((m) => (
                            <div
                                key={m.label}
                                data-testid={`maggie-metric-${m.label.replace(/\s+/g, "-").toLowerCase()}`}
                                className="bg-card p-6 text-center"
                            >
                                <p className="font-serif text-4xl font-medium tracking-tight md:text-5xl">
                                    {m.value}
                                </p>
                                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">
                                    {m.label}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-10">
                        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                            Interviews secured
                        </p>
                        <ul className="mt-4 space-y-2 font-serif text-lg text-foreground">
                            {MAGGIE_STORY.firms.map((f) => (
                                <li key={f} className="border-b border-border pb-2">
                                    {f}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default CaseStudy;
